module.exports = __webpack_public_path__ + "img/brushed-metal.348f76a6.png";